import type { Status } from "../lib/types";

const OPTS: { value: Status; label: string; active: string }[] = [
  { value: "keep", label: "Keep", active: "bg-green-600 text-white border-green-600" },
  { value: "maybe", label: "Maybe", active: "bg-amber-500 text-white border-amber-500" },
  { value: "cut", label: "Cut", active: "bg-red-600 text-white border-red-600" },
];

export function StatusControl({
  value,
  onChange,
  size = "sm",
  options,
}: {
  value: Status;
  onChange: (s: Status) => void;
  size?: "sm" | "md";
  /** Subset of statuses to offer (default: keep / maybe / cut). */
  options?: Status[];
}) {
  const pad = size === "md" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-xs";
  const opts = options ? OPTS.filter((o) => options.includes(o.value)) : OPTS;
  return (
    <div className="inline-flex overflow-hidden rounded border border-slate-300">
      {opts.map((o, i) => (
        <button
          key={o.value}
          onClick={() => onChange(value === o.value ? "unranked" : o.value)}
          className={`${pad} ${i > 0 ? "border-l border-slate-300" : ""} ${
            value === o.value ? o.active : "bg-white text-slate-600 hover:bg-slate-100"
          }`}
          title={value === o.value ? "Click to clear" : `Mark ${o.label}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
